var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function(tag,index){return _c('b-tag',{key:index},[_vm._v(_vm._s(tag.tag))])}),(_vm.moreCounter)?_c('b-tag',[_vm._v("+ "+_vm._s(_vm.moreCounter)+" More")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }